// import dateUtils from '@utils/DateUtils'

import vectorUtils from '@utils/vectorUtils'
import dateUtils from '@utils/DateUtils'

export default class Result {
  constructor (obj) {
    this._createdAt = obj.created_at ? dateUtils.convertUTCToLocalDateTime(obj.created_at) : undefined
    this._createdBy = obj.created_by
    this._downloadUrl = obj.download_url
    this._refs = obj.refs
    this._name = obj.file_name ? obj.file_name : obj.name ? obj.name : 'no name'
    this.loading = false
    this._format = obj.format
    this._id = obj.id
    this._imageId = obj.images ? obj.images.image_id : null
    this._meta = this.transformMeta(obj.meta)
    this._modelId = obj.model_id
    this._ownerId = 86
    this._path = obj.path
    this._imageRef = obj.ref_id
    this._modelName = obj.model_name ? obj.model_name : ''
    this._sizeMb = obj.size_mb ? obj.size_mb : 0
    this._taskId = obj.task_id
    this._tileUrl = obj.tile_url
    this._updatedAt = obj.updated_at ? dateUtils.convertUTCToLocalDateTime(obj.updated_at) : undefined
    this._workspaceId = obj.workspace_id
    this._categories = obj.categories ? obj.categories : []
    this._properties = {
      listValue: this.getListValue(obj.meta)
    }
    this._isOpenClass = false
    this._isExpand = !!(obj.meta && obj.meta.labels)
  }
  getListValue (meta) {
    if (meta && meta.labels) return meta.labels
    return []
  }
  transformMeta (meta) {
    if (meta && !meta.bbox && meta.geometry) {
      meta.bbox = vectorUtils.coordinatesToBBox(meta.geometry.features[0].geometry.coordinates)
    }
    return meta
  }

  checkRaster (format) {
    if (format === 'tif') {
      return true
    } else {
      return false
    }
  }

  get refs () {
    return this._refs
  }
  get properties () {
    return this._properties
  }
  get categories () {
    return this._categories
  }
  get modelName () {
    return this._modelName
  }
  get createdAt () {
    return this._createdAt
  }

  get isRaster () {
    return this.checkRaster(this._format)
  }

  get createdBy () {
    return this._createdBy
  }
  get workspaceId () {
    return this._workspaceId
  }
  get downloadUrl () {
    return this._downloadUrl
  }
  get name () {
    return this._name
  }

  get format () {
    return this._format
  }
  get imageId () {
    return this._imageId
  }

  get meta () {
    return this._meta
  }

  get modelId () {
    return this._modelId
  }

  get tileUrl () {
    return this._tileUrl
  }

  get id () {
    return this._id
  }

  get imageRef () {
    return this._imageRef
  }

  get ownerId () {
    return this._ownerId
  }

  get path () {
    return this._path
  }

  get sizeMb () {
    return this._sizeMb
  }

  get colorPalette () {
    return this._updatedAt
  }

  get taskId () {
    return this._taskId
  }

  get isOpenClass () {
    return this._isOpenClass
  }

  set isOpenClass (newValue) {
    this._isOpenClass = newValue
  }
  get isExpand () {
    return this._isExpand
  }

  set isExpand (newValue) {
    this._isExpand = newValue
  }
}



// WEBPACK FOOTER //
// ./src/models/results/result.js